import { makeSx } from '../../../../theme/_utils'
import { defaultPalette } from '../../../../theme/idsTheme'

export default makeSx({
    FormFieldWrapper: {
        position: 'relative',
        width: '100%',
        '& .Mui-disabled': {
            pointerEvents: 'auto',
        },
    },
    FormFieldLabel: {
        marginBottom: '0.375rem',
    },
    UsertFormFieldLabelDisabled: {
        opacity: 0.54,
    },
    FormFieldContent: {
        flex: 1,
        '&:hover': {
            '& .endAdornmentClear': {
                display: 'flex',
            },
        },
        '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
            paddingTop: 0,
            paddingBottom: 0,
            height: 'unset',
        },
    },
    FormFieldContentHorizontal: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: '.875rem',
        flexWrap: 'wrap',
        '& > div:nth-of-type(1)': {
            flex: 1,
        },
        '& .MuiInputBase-adornedStart': {
            columnGap: '.75rem',
        },
    },
    FormFieldErrorContainer: {
        marginTop: '.3rem',
        justifyContent: 'flex-start',
        padding: '0 1rem',
        width: '100%',
    },
    FormFieldErrorContainerText: {
        color: defaultPalette.red.main,
        fontSize: '0.875rem',
    },
    FormFieldHelperTextContainer: {
        marginTop: '.3rem',
        padding: '0 1rem',
    },
    FormFieldHelperTextWarning: {
        color: defaultPalette.orangeWarning.main,
        fontSize: '0.875rem',
    },
    FormFieldLabelIcon: {
        width: 'auto',
        height: '1.2rem',
    },
    FormFieldError: {
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: `${defaultPalette.red.main} !important`,
        },
        '& .TTD-ButtonSelector-button': {
            borderColor: `${defaultPalette.red.main} !important`,
        },
        '& .TTD-ButtonSelector-button-placeholder': {
            color: `${defaultPalette.red.main} !important`,
            opacity: 0.5,
        },
    },
    FormFieldWarning: {
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: `${defaultPalette.orangeWarning.main} !important`,
        },
        '& .TTD-ButtonSelector-button': {
            borderColor: `${defaultPalette.orangeWarning.main} !important`,
        },
        '& .TTD-ButtonSelector-button-placeholder': {
            color: `${defaultPalette.orangeWarning.main} !important`,
            opacity: 0.5,
        },
    },
    FormFieldLabelError: {
        color: defaultPalette.red.main,
    },
    FormFieldLabelValid: {
        color: defaultPalette.primary.main,
    },
    FormFieldLabelWarning: {
        color: defaultPalette.orangeWarning.main,
    },
    FormFieldActionButtonContainer: {
        width: '100%',
        paddingX: '0.5rem',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    FormFieldActionButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        marginTop: '0.375rem',
        width: 'fit-content',
        minWidth: '6.875rem',
        padding: ' 0.125rem 0.875rem',
        borderRadius: '0.25rem',
        backgroundColor: defaultPalette.lightGrey.mediumDark,
        color: defaultPalette.typography.main,
        transition: 'opacity 0.2s ease-out',
        '&:hover': {
            backgroundColor: defaultPalette.lightGrey.mediumDark,
            opacity: 0.75,
        },
    },
})
